// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Color Theme: Blue, White, Red, Yellow */
:root {
  --primary-blue: #1e3a8a;
  --secondary-blue: #3b82f6;
  --light-blue: #60a5fa;
  --dark-blue: #1e40af;
  
  --white: #ffffff;
  --off-white: #f8fafc;
  --light-gray: #e2e8f0;
  
  --primary-red: #dc2626;
  --secondary-red: #ef4444;
  --light-red: #fca5a5;
  
  --primary-yellow: #f59e0b;
  --secondary-yellow: #fbbf24;
  --light-yellow: #fcd34d;
  
  --text-primary: #1e293b;
  --text-secondary: #475569;
  --text-light: #94a3b8;
  
  --bg-primary: #f1f5f9;
  --bg-secondary: #e2e8f0;
  --bg-dark: #0f172a;
  
  --success: #22c55e;
  --error: #ef4444;
  --warning: #f59e0b;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  min-height: 100vh;
}

#root {
  min-height: 100vh;
}

/* Scrollbar styling */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: var(--bg-secondary);
}

::-webkit-scrollbar-thumb {
  background: var(--secondary-blue);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--primary-blue);
}

/* Button base styles */
.btn-primary {
  background-color: var(--primary-blue);
  color: var(--white);
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background-color: var(--dark-blue);
}

.btn-secondary {
  background-color: var(--secondary-red);
  color: var(--white);
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-secondary:hover {
  background-color: var(--primary-red);
}

.btn-outline {
  background-color: transparent;
  color: var(--primary-blue);
  border: 2px solid var(--primary-blue);
  padding: 8px 18px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-outline:hover {
  background-color: var(--primary-blue);
  color: var(--white);
}

/* Form elements */
input, textarea, select {
  background-color: var(--white);
  border: 2px solid var(--light-gray);
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 14px;
  color: var(--text-primary);
  transition: border-color 0.3s ease;
}

input:focus, textarea:focus, select:focus {
  outline: none;
  border-color: var(--secondary-blue);
}

/* Card styles */
.card {
  background-color: var(--white);
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

/* Badge styles */
.badge {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.badge-blue {
  background-color: var(--light-blue);
  color: var(--white);
}

.badge-red {
  background-color: var(--light-red);
  color: var(--white);
}

.badge-yellow {
  background-color: var(--light-yellow);
  color: var(--text-primary);
}

/* Status badges */
.status-badge {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.status-badge.scheduled {
  background-color: var(--secondary-blue);
  color: var(--white);
}

.status-badge.in-progress {
  background-color: var(--primary-yellow);
  color: var(--text-primary);
}

.status-badge.completed {
  background-color: var(--success);
  color: var(--white);
}

.status-badge.cancelled {
  background-color: var(--secondary-red);
  color: var(--white);
}

/* Links */
a {
  color: var(--secondary-blue);
  text-decoration: none;
  transition: color 0.3s ease;
}

a:hover {
  color: var(--primary-blue);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;;EAEpB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;;EAErB,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;;EAEpB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;;EAEvB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;;EAElB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;gEAC8D;EAC9D,mCAAmC;EACnC,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,uBAAuB;AACvB;EACE,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,qCAAqC;EACrC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA,gBAAgB;AAChB;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,6CAA6C;EAC7C,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/* Color Theme: Blue, White, Red, Yellow */\r\n:root {\r\n  --primary-blue: #1e3a8a;\r\n  --secondary-blue: #3b82f6;\r\n  --light-blue: #60a5fa;\r\n  --dark-blue: #1e40af;\r\n  \r\n  --white: #ffffff;\r\n  --off-white: #f8fafc;\r\n  --light-gray: #e2e8f0;\r\n  \r\n  --primary-red: #dc2626;\r\n  --secondary-red: #ef4444;\r\n  --light-red: #fca5a5;\r\n  \r\n  --primary-yellow: #f59e0b;\r\n  --secondary-yellow: #fbbf24;\r\n  --light-yellow: #fcd34d;\r\n  \r\n  --text-primary: #1e293b;\r\n  --text-secondary: #475569;\r\n  --text-light: #94a3b8;\r\n  \r\n  --bg-primary: #f1f5f9;\r\n  --bg-secondary: #e2e8f0;\r\n  --bg-dark: #0f172a;\r\n  \r\n  --success: #22c55e;\r\n  --error: #ef4444;\r\n  --warning: #f59e0b;\r\n}\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,\r\n    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\r\n  background-color: var(--bg-primary);\r\n  color: var(--text-primary);\r\n  min-height: 100vh;\r\n}\r\n\r\n#root {\r\n  min-height: 100vh;\r\n}\r\n\r\n/* Scrollbar styling */\r\n::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: var(--bg-secondary);\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: var(--secondary-blue);\r\n  border-radius: 4px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: var(--primary-blue);\r\n}\r\n\r\n/* Button base styles */\r\n.btn-primary {\r\n  background-color: var(--primary-blue);\r\n  color: var(--white);\r\n  border: none;\r\n  padding: 10px 20px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background-color: var(--dark-blue);\r\n}\r\n\r\n.btn-secondary {\r\n  background-color: var(--secondary-red);\r\n  color: var(--white);\r\n  border: none;\r\n  padding: 10px 20px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.btn-secondary:hover {\r\n  background-color: var(--primary-red);\r\n}\r\n\r\n.btn-outline {\r\n  background-color: transparent;\r\n  color: var(--primary-blue);\r\n  border: 2px solid var(--primary-blue);\r\n  padding: 8px 18px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.btn-outline:hover {\r\n  background-color: var(--primary-blue);\r\n  color: var(--white);\r\n}\r\n\r\n/* Form elements */\r\ninput, textarea, select {\r\n  background-color: var(--white);\r\n  border: 2px solid var(--light-gray);\r\n  border-radius: 6px;\r\n  padding: 10px 14px;\r\n  font-size: 14px;\r\n  color: var(--text-primary);\r\n  transition: border-color 0.3s ease;\r\n}\r\n\r\ninput:focus, textarea:focus, select:focus {\r\n  outline: none;\r\n  border-color: var(--secondary-blue);\r\n}\r\n\r\n/* Card styles */\r\n.card {\r\n  background-color: var(--white);\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\r\n  padding: 20px;\r\n}\r\n\r\n/* Badge styles */\r\n.badge {\r\n  padding: 4px 10px;\r\n  border-radius: 20px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.badge-blue {\r\n  background-color: var(--light-blue);\r\n  color: var(--white);\r\n}\r\n\r\n.badge-red {\r\n  background-color: var(--light-red);\r\n  color: var(--white);\r\n}\r\n\r\n.badge-yellow {\r\n  background-color: var(--light-yellow);\r\n  color: var(--text-primary);\r\n}\r\n\r\n/* Status badges */\r\n.status-badge {\r\n  padding: 4px 12px;\r\n  border-radius: 20px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.status-badge.scheduled {\r\n  background-color: var(--secondary-blue);\r\n  color: var(--white);\r\n}\r\n\r\n.status-badge.in-progress {\r\n  background-color: var(--primary-yellow);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.status-badge.completed {\r\n  background-color: var(--success);\r\n  color: var(--white);\r\n}\r\n\r\n.status-badge.cancelled {\r\n  background-color: var(--secondary-red);\r\n  color: var(--white);\r\n}\r\n\r\n/* Links */\r\na {\r\n  color: var(--secondary-blue);\r\n  text-decoration: none;\r\n  transition: color 0.3s ease;\r\n}\r\n\r\na:hover {\r\n  color: var(--primary-blue);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
